// Generated types for InquirySolvingTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface InquirySolvingTaskReadAPI extends LLMTaskReadAPI {
}

export interface InquirySolvingTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const InquirySolvingTaskReadAPISchema: z.ZodType<InquirySolvingTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const InquirySolvingTaskWriteAPISchema: z.ZodType<InquirySolvingTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
